import React, { useState, useEffect } from "react";
import "./BillwiseReport.css";

export default function StockMovementReport({fromDate,toDate}) {

  const [reportData, setReportData] = useState([]);

  useEffect(() => {
    if (fromDate && toDate) {
      fetchReport();
    }
  }, [fromDate, toDate]);

  const fetchReport = async () => {
    const res = await fetch(
      `/api/stock/movement?from=${fromDate}&to=${toDate}`
    );

    const data = await res.json();
    setReportData(data);
  };

  const handlePrint = () => {

    const printWindow = window.open("", "_blank");

    printWindow.document.write(`
      <html>
      <head>
        <title>Stock Movement Report</title>
        <style>
          body {
            font-family: Arial, sans-serif;
            padding: 20px;
          }

          .report-wrapper {
            border: 2px solid #000;
            padding: 10px;
          }

          .header-section {
            position: relative;
            margin-bottom: 15px;
              margin: -10px -10px 15px -10px; 
            border-bottom: 2px solid #000;
            padding-bottom: 10px;
          }

          .company-section {
            text-align: center;
          }

          .title {
            font-size: 20px;
            font-weight: bold;
          }

          .sub-title {
            margin-top: 4px;
            font-size: 14px;
          }

          .date-section {
            position: absolute;
            right: 0;
            top: 0;
            text-align: right;
            font-weight: bold;
            font-size: 14px;
          }

          table {
            width: 100%;
            border-collapse: collapse;
          }

          th, td {
            border: 1px solid #000;
            padding: 6px;
            font-size: 14px;
            text-align: center;
          }

          th {
            background: #eaeaea;
          }

        </style>
      </head>

      <body>

        <div class="report-wrapper">

          <div class="header-section">

            <div class="company-section">
              <div class="title">ORANGE TRADINGS</div>
              <div class="sub-title">
                DHARAPURAM ROAD, TIRUPUR - 641 601
              </div>
            </div>

            <div class="date-section">
              <div>From Date : ${fromDate}</div>
              <div>To Date&nbsp;&nbsp;&nbsp;: ${toDate}</div>
            </div>

          </div>

          <table>
            <thead>
              <tr>
                <th>Date</th>
                <th>Item</th>
                <th>Purchase</th>
                <th>Sales</th>
                <th>Running Stock</th>
              </tr>
            </thead>

            <tbody>
              ${reportData.map(row => `
                <tr>
                  <td>${row.date}</td>
                  <td>${row.itemName}</td>
                  <td>${Number(row.purchaseQty).toFixed(2)}$ {row.unitType}</td>
                  <td>${Number(row.salesQty).toFixed(2)}$ {row.unitType}</td>
                  <td>${Number(row.runningStock).toFixed(2)}$ {row.unitType}</td>
                </tr>
              `).join("")}
            </tbody>

<tfoot>
  <tr>
    <td colspan="2"><b>Total</b></td>
    <td><b>${totalPurchase.toFixed(2)}</b></td>
    <td><b>${totalSales.toFixed(2)}</b></td>
    <td></td>
  </tr>
</tfoot>

          </table>

        </div>

      </body>
      </html>
    `);

    printWindow.document.close();

    printWindow.onload = function () {
      printWindow.focus();
      printWindow.print();
      printWindow.close();
    };
  };
// Calculate totals
// Total Purchase
const totalPurchase = reportData.reduce(
  (sum, row) => sum + Number(row.purchaseQty || 0),
  0
);

// Total Sales
const totalSales = reportData.reduce(
  (sum, row) => sum + Number(row.salesQty || 0),
  0
);

// Total Stock (Latest running per item)
const latestStockMap = {};

reportData.forEach(row => {
  latestStockMap[row.itemId] = Number(row.runningStock || 0);
});

const totalStock = Object.values(latestStockMap).reduce(
  (sum, value) => sum + value,
  0
);
  return (
    <div className="billwise-container">


      <div className="billwise-table-section">

        <div className="billwise-table-wrapper">
          <table className="billwise-table">

            <thead>
              <tr>
                <th>Date</th>
                <th>Item</th>
                <th>Purchase</th>
                <th>Sales</th>
                <th>Stock</th>
              </tr>
            </thead>

           <tbody>
  {reportData.length > 0 ? (
    reportData.map((row, index) => (
      <tr key={index}>
        <td>{row.date}</td>
        <td>{row.itemName}</td>
        <td>{Number(row.purchaseQty).toFixed(2)} {row.unitType}</td>
        <td>{Number(row.salesQty).toFixed(2)} {row.unitType}</td>
        <td>{Number(row.runningStock).toFixed(2)} {row.unitType}</td>
      </tr>
    ))
  ) : (
    <tr>
      <td colSpan="5" className="no-data">
        No data found
      </td>
    </tr>
  )}
</tbody>
          </table>
        </div>
 

 <div className="del-summary">

  <div className="del-summary-row">

    <div className="summary-field ">
      <label>Total Purchase</label>
      <input value={Number(totalPurchase).toFixed(2)} readOnly />
    </div>

    <div className="summary-field ">
      <label>Total Sales</label>
      <input value={Number(totalSales).toFixed(2)} readOnly />
    </div>

     <div className="summary-field total">
      <label>Total Stock</label>
      <input value={Number(totalStock).toFixed(2)} readOnly />
    </div>


  </div>

</div>

       

        <div className="billwise-buttons">
          <button onClick={handlePrint}>Print</button>
        </div>

      </div>
    </div>
  );
}